import { coreUserService } from "../../users";
export class ScriptNetworkInfo {
    static getLocalClientId() {
        return coreUserService.getLocalUser().clientId;
    }
    static getDisplayName(clientId) {
        return coreUserService.getDisplayName(clientId);
    }
    static getLocalUserDisplayName() {
        return coreUserService.getDisplayName(coreUserService.getLocalUser().clientId);
    }
    static hasUser(clientId) {
        return coreUserService.hasUser(clientId);
    }
    static getUserInfo(clientId) {
        const user = coreUserService.getUser(clientId);
        if (!user)
            return undefined;
        const displayName = coreUserService.getDisplayName(clientId);
        if (!displayName)
            return;
        return {
            displayName,
            avatar: user.avatar
        };
    }
}
